import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const CourseReview = React.lazy(() =>
    import('../CourseReview')
);
const courseReviewRoutesRegistry = [
    {
        path: PAGE_URL.COURSE_REVIEW_PAGE,
        element: <CourseReview />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default courseReviewRoutesRegistry;
